
import CadminCompaniesAx from 'app/actions/company-admin/companies';
import CadminGrantsAx    from 'app/actions/company-admin/grants';
import history           from 'app/history';
import paths             from 'app/paths';
import CadminSlx         from 'app/selectors/company-admin/';
import PageSlx           from 'app/selectors/company-admin/page-grants';

const Types = {
  LOAD: 'CADMIN_PAGE_GRANTS_LOAD',
  SEARCH: 'CADMIN_PAGE_GRANTS_SEARCH',
};

const Actions = {

  load: ({params: {companySlug}, query}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(companySlug)),
      dispatch(Actions.search(companySlug, query)),
    ]);
    return dispatch({type: Types.LOAD, promise});
  },

  search: (companyId, params) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = dispatch(CadminGrantsAx.search(companyId, params));
    return dispatch({type: Types.SEARCH, promise});
  },

  setSearchParams: (newParams) => (dispatch, getState) => {
    const state = getState();
    const companySlug = CadminSlx.companySlug(state);
    const currentParams = PageSlx.searchParams(state);
    const params = {...currentParams, ...newParams};
    const path = paths.cadminGrants(companySlug, params);
    history.push(path);
  },

};

export {
  Types,
};

export default Actions;
